import React from "react";

// Time12Input: shows a friendly 12-hour picker (Hour / Minute / AM-PM) but stores
// the value as a 24-hour "HH:MM" string so the backend contract is unchanged.
// value: "HH:MM" (24h) — same shape as <input type="time"> so drop-in compatible
// onChange: (nextValue: "HH:MM") => void
export default function Time12Input({ value, onChange, testId }) {
  const parts = parse(value);

  const emit = (h12, min, ampm) => {
    let h24 = h12 % 12;
    if (ampm === "PM") h24 += 12;
    onChange(`${pad(h24)}:${pad(min)}`);
  };

  return (
    <div className="flex items-stretch gap-1" data-testid={testId}>
      <select
        value={parts.h12}
        onChange={(e) => emit(parseInt(e.target.value, 10), parts.min, parts.ampm)}
        className="border rounded-md h-10 px-2 bg-background text-sm flex-1 min-w-0"
      >
        {HOURS.map((h) => <option key={h} value={h}>{h}</option>)}
      </select>
      <span className="self-center text-muted-foreground">:</span>
      <select
        value={parts.min}
        onChange={(e) => emit(parts.h12, parseInt(e.target.value, 10), parts.ampm)}
        className="border rounded-md h-10 px-2 bg-background text-sm flex-1 min-w-0"
      >
        {MINUTES.map((m) => <option key={m} value={m}>{pad(m)}</option>)}
      </select>
      <select
        value={parts.ampm}
        onChange={(e) => emit(parts.h12, parts.min, e.target.value)}
        className="border rounded-md h-10 px-2 bg-background text-sm"
      >
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </select>
    </div>
  );
}

const HOURS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const MINUTES = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];

const pad = (n) => String(n).padStart(2, "0");

function parse(v) {
  const fallback = { h12: 6, min: 30, ampm: "PM" }; // 18:30
  if (!v || typeof v !== "string") return fallback;
  const m = v.match(/^(\d{1,2}):(\d{2})/);
  if (!m) return fallback;
  const h24 = parseInt(m[1], 10);
  const min = parseInt(m[2], 10);
  if (isNaN(h24) || isNaN(min)) return fallback;
  const ampm = h24 >= 12 ? "PM" : "AM";
  let h12 = h24 % 12;
  if (h12 === 0) h12 = 12;
  // Snap minute to nearest bucket so the dropdown always shows a matching value.
  const snapped = MINUTES.reduce((a, b) => Math.abs(b - min) < Math.abs(a - min) ? b : a, MINUTES[0]);
  return { h12, min: snapped, ampm };
}
